import clsxm from "@/lib/clsxm";
import {type CSSProperties, type FC, PropsWithChildren} from "react";

const SkeletonLoader: FC<PropsWithChildren<{className?: string; style?: CSSProperties}>> = ({
  children,
  className,
  style,
}) => {
  return (
    <div
      className={clsxm(
        "border-primary-light-solid animate-shimmer bg-good-grey-100 min-h-3 w-full rounded-full border",
        className,
      )}
      style={{
        backgroundImage: "var(--skeleton-shimmer)",
        backgroundSize: "700px 100%",
        backgroundRepeat: "no-repeat",
        ...style,
      }}>
      {children}
    </div>
  );
};

export default SkeletonLoader;
